export default __webpack_public_path__ + "static/media/pdf.099f8504.png";